export default __webpack_public_path__ + "static/media/power.2f2cd233.svg";